import { Center, Text } from '@mantine/core';
import { IconEyeCheck } from '@tabler/icons-react';
import { tKeys, useTranslation } from 'locales';

export const ActivitiesEmptyState = () => {
  const { t } = useTranslation();

  return (
    <Center my={100} style={{ flexDirection: 'column' }}>
      <IconEyeCheck size={100} />
      <Text mt={25} fz="xl">
        {t(tKeys.CLIENT.ACTIVITIES.EMPTY.TITLE)}
      </Text>
      <Text mt="sm" c="dimmed">
        {t(tKeys.CLIENT.ACTIVITIES.EMPTY.DESCRIPTION)}
      </Text>
    </Center>
  );
};
